module.exports = __webpack_public_path__ + "img/email.055e5ea5.svg";